import { axiosInstance } from "api/axios";
import { ISubmitFinancial } from "./types";

export const getMetaDataShareHolder = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/metadata/corporate-investors`);
	return data;
};

export const getDataShareHolder = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/actor-all`);
	return data;
};

export const getCommonMetaDataShareHolder = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/metadata/v2`);
	return data;
};

export const getListProgressCorporate = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/progress`);
	return data;
};

export const getListCompanyDetailCorporate = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/profile`);
	return data;
};

export const submitCompanyDetailCorporate = async (request: any): Promise<any> => {
	const response = await axiosInstance.post(`/corporate-investors/profile`, request);
	return response;
};
export const saveShareHolder = async (body: any): Promise<any> => {
	const { data } = await axiosInstance.post(
		`/corporate-investors/update-registration-detail-status-after-register-actors`,
		body,
	);
	return data;
};

export const submitFinancicalDeclaration = async (request: ISubmitFinancial): Promise<any> => {
	const data = await axiosInstance.put(`/corporate-investors/financial`, request);
	return data;
};

export const saveDraftFinancicalDeclaration = async (request: ISubmitFinancial): Promise<any> => {
	const data = await axiosInstance.post(`/corporate-investors/financial`, request);
	return data;
};

export const getCompanySummary = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/summary`);
	return data;
};

export const postCompanySummary = async (): Promise<any> => {
	const data = await axiosInstance.post(`/corporate-investors/summary`);
	return data;
};

export const getMetadataDocument = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/documents-metadata`);
	return data;
};

export const getListDocuments = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/corporate-documents`);
	return data;
};

export const getListCompliance = async (): Promise<any> => {
	const { data } = await axiosInstance.get(`/corporate-investors/compliance`);
	return data;
};

export const uploadDocumentFile = async (request: any): Promise<any> => {
	const response = await axiosInstance.post(`/document-tracker`, request);
	return response;
};

export const saveListDocuments = async (body: any): Promise<any> => {
	const data = await axiosInstance.post(`corporate-investors/corporate-documents`, body);
	return data;
};

export const savePepDeclaration = async (body: any): Promise<any> => {
	const data = await axiosInstance.put(`corporate-investors/pep-declaration`, body);
	return data;
};

export const saveDraftPepDeclaration = async (body: any): Promise<any> => {
	const data = await axiosInstance.put(`corporate-investors/pep-declaration`, body);
	return data;
};

export const updateAuthorRepresentativeCreate = async (body: {
	representativeId: string;
}): Promise<any> => {
	const data = await axiosInstance.post(`corporate-investors/updateRepresentativeOfNew`, body);
	return data;
};

export const updateAuthorRepresentative = async (body: {
	representativeId: string;
}): Promise<any> => {
	const data = await axiosInstance.post(`corporate-investors/updateRepresentative`, body);
	return data;
};
